<style src="./BidMIrror.scss" lang="scss"></style>
<template>
  <section class="bid-mirror">
    <content-header path="Resultado" />
    <event-details-header
      :event-id="eventId" />

    <section class="main-container row">
      <mirror-form
        :event-id="eventId" />
    </section>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import MirrorForm from '@/components/bid-mirror/mirror-form/MirrorForm'
import EventDetailsHeader from '@/components/foundation/event-details-header/EventDetailsHeader'

export default {
  name: 'BidMIrror',
  components: {
    ContentHeader,
    EventDetailsHeader,
    MirrorForm
  },
  data () {
    return {
      categories: []
    }
  },
  computed: {
    stage () {
      return this.$store.getters['Board/STAGE_BY_NAME']('Resultado')
    },
    eventId () {
      return this.$route.params.id
    }
  },
  mounted () {},
  methods: {}
}
</script>


// WEBPACK FOOTER //
// src/view/bid-mirror/BidMirror.vue